export { states } from "./stateAndLocal";

export const default_z_index: number = 100;
